import { createAction, props } from '@ngrx/store';
import { CameraTimeline } from '../../service/vehicale-dvr-video.serevice';
import { CameraInfo } from '../../models/camera/camera-info';
import { CameraState } from '../../models/camera/camera-state';
import { ClipInterface } from '../../models/camera/clip.interface';
import { Update } from '@ngrx/entity';

export const getVideoRequestEvent = createAction(
  '[Camera] Get Video Request Event',
  props<{
    camera: string;
    lower: string;
    upper: string;
    sources: string[];
    title: string;
    description: string;
  }>(),
);

export const getVideoRequestEventSuccess = createAction(
  '[Camera] Get Video Request Event Success',
  props<{ data: ClipInterface }>(),
);
export const setCameraStateFromEventSource = createAction(
  '[Camera] Set Camera State From Event Source',
  props<{ state: CameraState }>(),
);

export const loadCurrentCameraStatus = createAction(
  '[Camera] Load Current Camera Status',
  props<{ cameraId: number }>(),
);
export const loadCurrentCameraStatusSuccess = createAction(
  '[Camera] Load Current Camera Status Success',
  props<{ cameraState: CameraState }>(),
);
export const getCurrentCameraInfo = createAction(
  '[Camera] Get Current Camera Info',
  props<{ cameraId: number }>(),
);

export const getCurrentCameraInfoSuccess = createAction(
  '[Camera] Get Current Camera Info Success',
  props<{ currentCameraInfo: CameraInfo }>(),
);

export const loadClips = createAction(
  '[Camera] Load Clips',
  props<{
    vehicleId: number;
    lowerDate: string;
    upperDate: string;
  }>(),
);

export const loadClipsSuccess = createAction(
  '[Camera] Load Clips Success',
  props<{ data: ClipInterface[] }>(),
);

export const loadCamerasFailure = createAction(
  '[Camera] Load Cameras Failure',
  props<{ error: any }>(),
);

export const setCameraSortBy = createAction(
  '[Camera] Set Camera Sort By',
  props<{ sortBy: string }>(),
);

export const setCameraFilterBy = createAction(
  '[Camera] Set Camera Filter By',
  props<{ filterBy: string }>(),
);

export const getCameraVideoHistory = createAction(
  '[Camera] Get Camera Video History',
  props<{ cameraSerial: number }>(),
);

export const getCameraVideoHistorySuccess = createAction(
  '[Camera] Get Camera Video History Success',
  props<{ videoHistory: CameraTimeline }>(),
);

export const getCameraVideoHistoryError = createAction(
  '[Camera] Get Camera Video History Error',
  props<{ error: any }>(),
);

export const deleteVideoClip = createAction(
  '[Camera] Delete video clip',
  props<{ clip: ClipInterface }>(),
);
export const updateVideoClip = createAction(
  '[Camera] Update video clip',
  props<{ clip: { id: number; title: string; description: string } }>(),
);

export const updateVideoClipSuccess = createAction(
  '[Camera] Update video clip Success',
  props<{ clip: Update<{ id: number; title: string; description: string }> }>(),
);
export const setClipProgressFromEventSource = createAction(
  '[Camera] Set Clip Progress From Event Source',
  props<{ clip: Update<ClipInterface> }>(),
);

export const deleteVideoClipSuccess = createAction(
  '[Camera] Delete video clip Success',
  props<{ clipId: number }>(),
);

export const cancelClipRequest = createAction('[Camera] Cancel Clip Request');
export const clearAllCameraInfo = createAction(
  '[Camera] Clear All Camera Data',
);
